import React, { useState } from 'react';

import { dayFormatType, formatDay } from '~helpers/day';

import InfoRow from './info-row';
import PMSModal from '../../../pms-modal';

export default function BasicInfo({ t, pmsDetail, refetch = () => {} }) {
  const [visible, setVisible] = useState(false);

  const handleOnClose = () => setVisible(false);
  const handleOnOpen = () => setVisible(true);

  return (
    <div className="pms-basic-info">
      <div className="info-title">{t('cms:cms.landlord.detail.basic_info.tab')}</div>
      <InfoRow label="PMS name" value={pmsDetail?.name ?? '-'} t={t} onEdit={handleOnOpen} />
      <InfoRow
        label="Account manager"
        value={pmsDetail?.emailAddress ?? '-'}
        t={t}
        onEdit={handleOnOpen}
      />
      <InfoRow
        label="Callback URL"
        value={pmsDetail?.webhook?.callbackUrl ?? '-'}
        t={t}
        onEdit={handleOnOpen}
      />
      <InfoRow
        label="Created time"
        showEdit={false}
        value={pmsDetail?.createdAt ? formatDay(dayFormatType.UKFORMAT, pmsDetail.createdAt) : '-'}
        t={t}
      />
      <InfoRow
        label="Notes"
        value={pmsDetail?.note ?? '-'}
        noBorder={true}
        t={t}
        onEdit={handleOnOpen}
      />

      <PMSModal
        t={t}
        onClose={handleOnClose}
        visible={visible}
        refetch={refetch}
        pmsAccount={pmsDetail}
        type="edit"
      />
    </div>
  );
}
